import { render, staticRenderFns } from "./Cobertura.vue?vue&type=template&id=13ff36a3"
import script from "./Cobertura.vue?vue&type=script&lang=js"
export * from "./Cobertura.vue?vue&type=script&lang=js"
import style0 from "./Cobertura.vue?vue&type=style&index=0&id=13ff36a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports